/**
 * Critério da busca livre de contas a pagar.
 * @param {Object} conta - Conta já processada por processarContas
 * @param {string} busca - Texto digitado
 * @returns {boolean}
 */
export const contaCasaComBusca = (conta, busca) => {
  const termo = busca.toLowerCase();
  return Boolean(
    (conta.fornecedor && String(conta.fornecedor).toLowerCase().includes(termo)) ||
    (conta.descricao && String(conta.descricao).toLowerCase().includes(termo)) ||
    (conta.observacao && String(conta.observacao).toLowerCase().includes(termo)) ||
    (conta.conta_analitica && String(conta.conta_analitica).toLowerCase().includes(termo)) ||
    (conta.planejamento && String(conta.planejamento).toLowerCase().includes(termo)) ||
    conta.id?.toString().includes(busca)
  );
};
